import { render, staticRenderFns } from "./module_a.vue?vue&type=template&id=1dd6738a&scoped=true&"
import script from "./module_a.vue?vue&type=script&lang=js&"
export * from "./module_a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd6738a",
  null
  
)

export default component.exports